import clsx from 'clsx';
import { Icon } from './Icon';

interface StarBadgeProps {
  className?: string;
  iconClassName?: string;
}

export function StarBadge({ className, iconClassName }: StarBadgeProps) {
  return (
    <div
      className={clsx(
        className,
        'rounded-full StarBadge grid place-content-center border border-palette-1100 bg-palette-600 aspect-square h-4 w-4 box-content'
      )}
    >
      <Icon className={clsx(iconClassName, 'StarBadge-icon text-palette-1100 h-3 w-3')} icon="star" />
    </div>
  );
}
